<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/crs/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import quill from "@/components/page/quill.vue"
  import Qs from 'qs'
  import axios from 'axios'

  let businessIds={};//业务id
  let language={};//语言
  let channel108={};//108
  let channel72={};//72
  let channel36={};//36
  let messageList ={"1":"重要公告","2":"交易时间安排","3":"系统维护公告","4":"最新优惠","5":"专属回馈","6":"新闻早班车","7":"行情提醒","8":"服务提示","9":"问答快讯","10":"通知","11":"我的预警"};
  let pushMode={"1":"即时","2":"定时"};//推送方式

  let syncList={"1":"官网","2":"用户中心","3":"PCUI"};//同步到
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
            if(typeof row.releaseStatus =="string"){
                if(row.releaseStatus.indexOf(",")!=-1){
                    row.releaseStatus=row.releaseStatus.split(",");
                }else{
                    let channel1=[];
                    channel1.push(row.releaseStatus);
                    row.releaseStatus=channel1;
                }
            }
          this.$refs.childUpdate.open(row);
        } else if(clickName == "delete"){
            this.$axios.get(URL.pushMsg.del+"?id="+row.id).then(res=> {
                if (res.code == 0) {
                    this.$message.success("suc");
                    this.$refs.childTable.defaultGetData(this.queryData);
                }
            });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName  || window.$t("common.search") == clickName){
          this.queryData = data;
            if(data.pushTime!=undefined &&data.pushTime.indexOf(",")!=-1){
                let timeArr=data.pushTime.split(",");
                data.endDateTime=timeArr[1];
                data.startDateTime=timeArr[0];
            }
            data.releaseStatus="1,2,3";
          this.$refs.childTable.defaultGetData(data);
        }else if("+发布消息公告" == clickName || window.$t("crs.pushMsg.fabu") == clickName){
            this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
          if(model.releaseStatus==null || model.releaseStatus==undefined || model.releaseStatus==''){
              model.releaseStatus='';
          }else if(model.releaseStatus.length>1){
              model.releaseStatus= model.releaseStatus.join(",");
          }else{
              model.releaseStatus=model.releaseStatus[0]+"";
          }
          if(model.id==undefined || model.id ==null || model.id == ''){
              model.users=this.user;
          }
        //根据是否包含id更新还是添加
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.pushMsg.edit:URL.pushMsg.save,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
           this.$refs.childTable.defaultGetData(this.queryData);
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[

          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle'},
              { title: window.$t("crs.pushMsg.yewu"), field: 'channel',type:2,optionList:businessIds},
              { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage',type:2,optionList:{"zh_CN":"zh_CN","en_US":"en_US","vi_VN":"vi_VN"}},
              { title: window.$t("crs.pushMsg.createDate"), field: 'createDate',type:6},
              {click:window.$t("common.search"),auth:"sys:listMsg:find"},
              {click:window.$t("crs.pushMsg.fabu"),auth:"sys:listMsg:save"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.pushMsg.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle'},
              { title: window.$t("crs.pushMsg.msgRemark"), field: 'msgRemark'},
              { title: window.$t("crs.pushMsg.type"), field: 'type',render:(data)=>{
                              return messageList[data];
                          }},
              { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage'},
              { title: window.$t("crs.pushMsg.businessId"), field: 'businessId'},
              { title: window.$t("crs.pushMsg.status"), field: 'status',render:(data)=>{
                 return data==1 ? window.$t("common.start"):window.$t("common.stop");
               }},
              { title: window.$t("crs.pushMsg.platform"), field: 'releaseStatus',render:(data)=>{
                  let str="";
                      if(data.indexOf("1")!=-1){
                          str+="官网,";
                      }
                      if(data.indexOf("2")!=-1){
                          str+="用户中心,";
                      }
                      if(data.indexOf("3")!=-1){
                          str+="PCUI,";
                      }
                      return str.substring(0,str.lastIndexOf(","));
                  }},
              { title: window.$t("crs.pushMsg.updateDate"), field: 'updateDate'},
              {title:window.$t("common.handle"),btnClick:[
                 {name:window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete",auth:"sys:listMsg:delete"},
                 {name:window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit",auth:"sys:listMsg:edit"}
              ]},
          ]
        }
      }
    } ,
      created(){
          this.$axios.get(URL.pushMsg.getData).then(res=> {
              if (res.code == 0) {
                  language=res.result.language;
                  businessIds=res.result.businessIds;
                  // channel72=res.result.channel72;
                  // channel36=res.result.channel36;
                  this.updateData.cols=[
                      {title:'id',field:'id',hidden:true},
                      { title: window.$t("crs.pushMsg.businessId"), field: 'businessId',type:3,optionList:businessIds,data:"108",required:true},
                      { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage',type:3,optionList:language,data:"zh_CN",required:true},
                      { title: window.$t("crs.pushMsg.type"), field: 'type',type:2,required:true,optionList:messageList,data:[],isNumber:true},
                      { title: window.$t("crs.pushMsg.pushMode"), field: 'pushMode',type:3,optionList:pushMode,data:1,isNumber:true,required:true},
                      { title:window.$t("crs.pushMsg.pushTime"), field: 'pushTime',type:5,hidden:(model,col)=>{return model.pushMode == "1";},required:(model,col)=>{
                              return model.pushMode == "2";
                          }},
                      { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle',required:true},
                      { title: window.$t("crs.pushMsg.msgRemark"), field: 'msgRemark',textType:"textarea"},
                      { title: window.$t("crs.pushMsg.msgContent"), field: 'msgContent',type:6},
                      { title: window.$t("crs.pushMsg.fabudao"), field: 'releaseStatus',type:4,hasCheckAll:true,checkAll:false,data:[],optionList:syncList,required:true}
                  ];
                  this.formData.cols=[
                      { title: window.$t("crs.pushMsg.msgTitle"), field: 'msgTitle'},
                      { title: window.$t("crs.pushMsg.business"), field: 'channel',type:2,optionList:businessIds},
                      { title: window.$t("crs.pushMsg.msgLanguage"), field: 'msgLanguage',type:2,optionList:{"zh_CN":"zh_CN","en_US":"en_US","vi_VN":"vi_VN"}},
                      { title: window.$t("crs.pushMsg.status"), field: 'status',type:2,optionList:{"1":"启用","2":"停用"}},
                      { title: window.$t("crs.pushMsg.pushTime"), field: 'pushTime',type:6},
                      {click:window.$t("common.search"),auth:"sys:listMsg:find"},
                      {click:window.$t("crs.pushMsg.fabu"),auth:"sys:listMsg:save"}
                      ];
              }
          });
      }
  }
</script>
